export default "__VITE_ASSET__B6c5CKoT__"